'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var passiveEvents = {};

exports.__exports = passiveEvents;
